import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ConversionService {
  public getDateFormatFromDate(date: Date) {
    if (this.isValidDate(date)) {
      return (
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
        '/' +
        (date.getMonth() < 9
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        '/' +
        date.getFullYear()
      );
    }
    return '';
  }

  public getAirlineDateFormatFromStr(dateStr: string) {
    if (!!dateStr) {
      const date = new Date(dateStr);
      return moment(date).format('DD MMM YYYY');
    }
    return '';
  }

  public getAirlineDateFormatFromDate(date: Date) {
    if (date) {
      return moment(date).format('DD MMM YYYY');
    } else {
      return 'invalid date';
    }
  }

  public getAirlineDateWithHourFormatFromDate(date: Date) {
    return moment(date).format('DD MMM YYYY HH:mm');
  }

  public getAirlineHourFormatFromDate(date: Date) {
    if (date) {
      return moment(date).format('HH:mm');
    } else {
      return '--:--';
    }
  }

  public getDateFormatFromStr(dateStr: string) {
    if (!!dateStr) {
      const date = new Date(dateStr);
      return (
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
        '/' +
        (date.getMonth() < 9
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        '/' +
        date.getFullYear()
      );
    }
    return '';
  }

  public getDateTimeFormatFromStr(dateStr: string) {
    const date = new Date(dateStr);
    return (
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
      '/' +
      (date.getMonth() < 9
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      '/' +
      date.getFullYear() +
      ' ' +
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
      ':' +
      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      ':' +
      (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    );
  }

  public getDateTimeFormatFromDate(date: Date) {
    return (
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
      '/' +
      (date.getMonth() < 9
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      '/' +
      date.getFullYear() +
      ' ' +
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
      ':' +
      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      ':' +
      (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    );
  }

  public getDateTimeFormatForInsert(date: Date) {
    return (
      date.getFullYear() +
      '-' +
      (date.getMonth() < 9
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      '-' +
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
      ' ' +
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
      ':' +
      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      ':' +
      (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    );
  }

  public isValidDate(d) {
    return d instanceof Date && !isNaN(d.getDate());
  }

  public getDateFormatForInsert(date: Date) {
    return (
      date.getFullYear() +
      '-' +
      (date.getMonth() < 9
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      '-' +
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
      ' '
    );
  }
}
